<template>
    <div class="centerx">
      <vs-popup
        :title="'Detalle | Campaña: ' + (modalData && modalData.campaignId && modalData.companyId ? `${modalData.campaignId} - Empresa: ${modalData.companyId}` + (modalData.isProgrammatic ? '  | Programática' : '  | Tradicional') : 'Detalle')"
        :active.sync="isModalActive"
        @close="handleClose"
        fullscreen
        class="content-display-detail vs-con-loading__container"
      >
        <div class="flex flex-col justify-between gap-10 h-full overflow-y-auto px-4">
          <section class="flex flex-col gap-10">
            <div class="rounded-lg overflow-hidden">
              <h4>ODCs de cliente/agencia</h4>
              <agency-odc-table
                :data="data && data.purchase_orders_agency ? data.purchase_orders_agency : []"
              />
            </div>
            <!-- NEW SECTION: Sales Closures Table -->
            <div v-if="modalData" class="rounded-lg overflow-hidden">
              <h4>Cierres de ventas</h4>
              <sales-closures-table
                :campaign-id="modalData.campaignId"
                :total-income="amounts.totalIncome"
              />
            </div>
            <div class="rounded-lg overflow-hidden">
              <h4>ODCs de empresas de medios provisorias</h4>
              <company-odc-table
                :data="data && data.purchase_orders ? data.purchase_orders : []"
                :is-final-table="false"
                title="ODCs de empresas de medios provisorias"
                @getPurchaseOrderData="getPurchaseOrderData"
              />
            </div>
            <div class="rounded-lg overflow-hidden">
              <div class="flex justify-between mb-2 items-end">
                <h4>ODCs de empresas de medios finales</h4>
              </div>
              <div v-for="(monthData, index) in data && data.purchase_orders_grouped_by_month ? data.purchase_orders_grouped_by_month : []" :key="index">
                <div class="flex justify-between bg-grey-light px-4 py-2">
                  <h5 class="p-2 flex-1">{{ monthData.year }} - {{ monthFormatter(monthData.month) }}</h5>
                  <div class="flex items-center gap-4">
                    <div class="flex items-center gap-2">
                      <span class="text-sm">Ver anuladas</span>
                      <vs-switch :value="getShowCanceledForMonth(monthData.year, monthData.month)" @input="toggleShowCanceledForMonth(monthData.year, monthData.month, $event)" />
                    </div>
                    <vx-tooltip :text="'Esta opción solo está disponible para campañas programáticas'" :disabled="Boolean(modalData.isProgrammatic)">
                      <vs-button
                        class="bg-latinad-light text-white hover:bg-latinad transition-colors"
                        size="small"
                        :disabled="!Boolean(modalData.isProgrammatic)"
                        @click="closePurchaseOrdersByMonth({
                          month: monthData.month,
                          year: monthData.year
                        })"
                      >Generar ODC {{ monthFormatter(monthData.month) }}</vs-button>
                    </vx-tooltip>
                  </div>
                </div>
                <company-odc-table
                  :data="filterPurchaseOrdersByMonth(monthData.purchase_orders, monthData.year, monthData.month)"
                  :is-final-table="true"
                  :showCheckboxes="true"
                  :selectedCompanies="getSelectedCompaniesForMonth(monthData.year, monthData.month)"
                  @getPurchaseOrderData="getPurchaseOrderData"
                  @toggleCompanySelection="toggleCompanySelectionForMonth(monthData.year, monthData.month, $event)"
                  @selectAllCompanies="selectAllCompaniesForMonth(monthData.year, monthData.month, $event)"
                />
              </div>
              <div class="p-2 px-4 flex justify-between bg-grey-dark text-white rounded-sm items-center">
                <span class="font-bold text-xl">Total gasto:</span>
                <span class="font-bold rounded-lg p-2 bg-white text-latinad">{{stringCurrencyFormatter(amounts.totalSpent)}}</span>
              </div>
            </div>
          </section>
          <section>
            <div class="p-2 px-4 flex justify-between items-center bg-latinad text-white rounded-lg">
              <span class="font-bold text-xl">Total</span>
              <span class="font-bold p-2 rounded-lg bg-white" :style="{color: amounts.total >= 0 ? '#0096f5' : '#A50400'}" title="Total ingreso - Total gasto">{{stringCurrencyFormatter(amounts.total)}}</span>
            </div>
          </section>
        </div>
      </vs-popup>
    </div>
</template>

<style>
  .center .vs-table-text {
    justify-content: center !important;
  }

  .content-display-detail .vs-popup--content {
    height: 100% !important;
    position: relative !important;
  }

  .vs-tooltip {
    z-index: 100000;
  }
</style>

<script>
import { stringCurrencyFormatter, dateFormatter, monthFormatter } from '../../../utils/strings';
import appConfig from '@/../appConfig.js'

import AgencyOdcTable from './components/AgencyOdcTable.vue'
import CompanyOdcTable from './components/CompanyOdcTable.vue'
import SalesClosuresTable from './components/SalesClosuresTable.vue'
export default {
    name: "closings-details",
    props: {
        modalActive: {
          type: Boolean,
          default: false
        },
        modalData: {
          type: Object,
          default: null
        }
    },
    components: {
      AgencyOdcTable,
      CompanyOdcTable,
      SalesClosuresTable
    },
    data() {
      return {
        stringCurrencyFormatter,
        dateFormatter,
        monthFormatter,
        data: null,
        isModalActive: false,
        isLoading: false,
        showCanceledOdcsByMonth: {},
        selectedCompaniesByMonth: {},
        loadingInstance: null,
        amounts: {
          totalSpent: 0,
          totalIncome: 0,
          total: 0
        }
      }
    },
    watch: {
      modalData: {
        deep: true,
        handler() {
          if (this.modalData) {
            this.selectedCompaniesByMonth = {};
            this.getPurchaseOrderData()
          }
        },
        immediate: false
      },
      modalActive: {
        handler(newValue) {
          this.isModalActive = newValue
          if (!newValue) {
            this.selectedCompaniesByMonth = {};
            this.closeLoading()
          }
        },
        immediate: true
      },
      isLoading() {
        // Ya no usamos overlay de Vuesax
      }
    },
    methods: {
      resolveExistingPurchaseOrderId(error) {
        const status = error && error.response ? Number(error.response.status) : null;
        if (status !== 409) {
          return null;
        }

        const responseData = error && error.response ? error.response.data : null;
        if (!responseData) {
          return null;
        }

        if (responseData.purchase_order_id) {
          return responseData.purchase_order_id;
        }

        if (responseData.data && responseData.data.purchase_order_id) {
          return responseData.data.purchase_order_id;
        }

        return null;
      },
      mergeSplitWithExistingPurchaseOrders(splitRows, purchaseOrders) {
        if (!Array.isArray(splitRows)) return [];

        const existingOrders = Array.isArray(purchaseOrders) ? purchaseOrders : [];

        return splitRows.map((splitRow) => {
          if (splitRow && splitRow.id) {
            return splitRow;
          }

          if (!splitRow || !splitRow.is_secured_investment) {
            return splitRow;
          }

          const matches = existingOrders.filter((purchaseOrder) => {
            const samePeriod = (!splitRow.start_period || !purchaseOrder.start_period || splitRow.start_period === purchaseOrder.start_period)
              && (!splitRow.end_period || !purchaseOrder.end_period || splitRow.end_period === purchaseOrder.end_period);
            const existingMonth = Number(purchaseOrder.month);
            const splitMonth = Number(splitRow.month);
            const sameMonth = existingMonth === splitMonth || existingMonth === 0 || Number.isNaN(existingMonth);

            return Number(purchaseOrder.company_id) === Number(splitRow.company_id)
              && sameMonth
              && Number(purchaseOrder.year) === Number(splitRow.year)
              && samePeriod
              && Boolean(purchaseOrder.is_secured_investment);
          });

          if (!matches.length) {
            return splitRow;
          }

          const activeMatch = matches.find((purchaseOrder) => !purchaseOrder.canceled_at) || matches[0];

          return {
            ...splitRow,
            ...activeMatch,
            total_amount: splitRow.total_amount,
            secured_investment_amount: splitRow.secured_investment_amount || activeMatch.secured_investment_amount,
            secured_investment_currency: splitRow.secured_investment_currency || activeMatch.secured_investment_currency
          };
        });
      },
      openLoading() {
        // Ya no usamos Vuesax loading, solo el spinner local en SalesClosuresTable
      },
      closeLoading() {
        // Ya no usamos Vuesax loading, solo el spinner local en SalesClosuresTable
      },
      getMonthKey(year, month) {
        return year + '-' + month;
      },
      getShowCanceledForMonth(year, month) {
        const key = this.getMonthKey(year, month);
        return this.showCanceledOdcsByMonth[key] || false;
      },
      toggleShowCanceledForMonth(year, month, value) {
        const key = this.getMonthKey(year, month);
        this.$set(this.showCanceledOdcsByMonth, key, value);
      },
      filterPurchaseOrdersByMonth(purchaseOrders, year, month) {
        const showCanceled = this.getShowCanceledForMonth(year, month);
        if (showCanceled) {
          return purchaseOrders;
        }
        return purchaseOrders.filter(function(po) {
          return !po.canceled_at;
        });
      },
      getSelectedCompaniesForMonth(year, month) {
        var key = this.getMonthKey(year, month);
        return this.selectedCompaniesByMonth[key] || [];
      },
      initializeSelectedCompaniesForMonth(year, month, purchaseOrders) {
        const key = this.getMonthKey(year, month);
        const securedCompanyIds = [];
        const fallbackCompanyIds = [];

        for (let i = 0; i < purchaseOrders.length; i++) {
          const companyId = purchaseOrders[i].company_id;

          if (fallbackCompanyIds.indexOf(companyId) === -1) {
            fallbackCompanyIds.push(companyId);
          }

          if (purchaseOrders[i].is_secured_investment && securedCompanyIds.indexOf(companyId) === -1) {
            securedCompanyIds.push(companyId);
          }
        }

        this.$set(
          this.selectedCompaniesByMonth,
          key,
          securedCompanyIds.length > 0 ? securedCompanyIds : fallbackCompanyIds
        );
      },
      toggleCompanySelectionForMonth(year, month, companyId) {
        const key = this.getMonthKey(year, month);
        const selectedCompanies = this.selectedCompaniesByMonth[key] || [];
        const index = selectedCompanies.indexOf(companyId);

        if (index !== -1) {
          selectedCompanies.splice(index, 1);
        } else {
          selectedCompanies.push(companyId);
        }

        this.$set(this.selectedCompaniesByMonth, key, selectedCompanies);
      },
      selectAllCompaniesForMonth(year, month, companyIds) {
        const key = this.getMonthKey(year, month);
        const selectedCompanies = this.selectedCompaniesByMonth[key] || [];

        if (selectedCompanies.length === companyIds.length) {
          this.$set(this.selectedCompaniesByMonth, key, []);
        } else {
          this.$set(this.selectedCompaniesByMonth, key, companyIds);
        }
      },
      getMonthPurchaseOrders(year, month) {
        const grouped = this.data && this.data.purchase_orders_grouped_by_month ? this.data.purchase_orders_grouped_by_month : [];
        const monthData = grouped.find((item) => Number(item.year) === Number(year) && Number(item.month) === Number(month));
        return monthData && Array.isArray(monthData.purchase_orders) ? monthData.purchase_orders : [];
      },
      parseNumber(value) {
        if (value === null || value === undefined || value === '') return null;

        const parsed = Number(String(value).replace(',', '.').trim());
        return Number.isFinite(parsed) ? parsed : null;
      },
      buildSecuredPayload(purchaseOrder) {
        const amountCandidates = [
          purchaseOrder.total_amount,
          purchaseOrder.secured_investment_amount,
          purchaseOrder.secured_investment_amount_local
        ];

        let amount = 0;
        for (let i = 0; i < amountCandidates.length; i++) {
          const parsed = this.parseNumber(amountCandidates[i]);
          if (parsed !== null && parsed > 0) {
            amount = parsed;
            break;
          }
        }

        return {
          company_id: purchaseOrder.company_id,
          total_amount: amount,
          currency: purchaseOrder.currency || purchaseOrder.secured_investment_currency || 'USD'
        };
      },
      async createSecuredPurchaseOrdersForRows(rows) {
        const rowsByCompany = rows.reduce((acc, row) => {
          if (!acc[row.company_id]) {
            acc[row.company_id] = row;
          }
          return acc;
        }, {});

        const uniqueRows = Object.values(rowsByCompany);

        for (let i = 0; i < uniqueRows.length; i++) {
          const payload = this.buildSecuredPayload(uniqueRows[i]);

          if (!payload.total_amount || payload.total_amount <= 0) {
            continue;
          }

          try {
            await this.$http.post(
              `${appConfig.apiUrl}/campaigns/${this.modalData.campaignId}/purchase_orders/secure`,
              payload
            );
          } catch (error) {
            const existingPurchaseOrderId = this.resolveExistingPurchaseOrderId(error);

            if (!existingPurchaseOrderId) {
              throw error;
            }
          }
        }
      },
      getPurchaseOrderData() {
        this.isLoading = true
        this.$http.get(`${appConfig.apiUrl}/campaigns/${this.modalData.campaignId}/purchase_orders`)
        .then(response => {
          const { purchase_orders_agency, purchase_orders, purchase_orders_split } = response.data
          const enrichedPurchaseOrdersSplit = this.mergeSplitWithExistingPurchaseOrders(purchase_orders_split, purchase_orders);

          // Join purchase_orders_split by month
          const groupedPurchaseOrdersSplitByMonth = Object.values(
            enrichedPurchaseOrdersSplit.reduce((acc, po) => {
              const key = `${po.year}-${po.month}`;

              if (!acc[key]) {
                acc[key] = {
                  year: po.year,
                  month: po.month,
                  purchase_orders: []
                };
              }

              acc[key].purchase_orders.push(po);
              return acc;
            }, {})
          );

          this.calculateAmounts(this.modalData.totalIncome, enrichedPurchaseOrdersSplit)

          this.data = {
            purchase_orders_agency,
            purchase_orders,
            purchase_orders_grouped_by_month: groupedPurchaseOrdersSplitByMonth
          }

          const vm = this;
          groupedPurchaseOrdersSplitByMonth.forEach(function(monthData) {
            vm.initializeSelectedCompaniesForMonth(
              monthData.year,
              monthData.month,
              monthData.purchase_orders
            );
          });
        })
        .catch(error => {
          console.error('[ClosingsDetails] Error:', error)
          this.$vs.notify({
            title: 'Error',
            text: 'Error al obtener las ODCs',
            color: 'danger'
          });
        })
        .finally(() => {
          this.isLoading = false
        })
      },
      //Esto va a cambiar en un futuro
      calculateAmounts(income, purchase_orders_split){

        const removedCanceledPurchaseOrders = purchase_orders_split.filter(po => !po.canceled_at);

        const totalSpent = removedCanceledPurchaseOrders.reduce((acc, po) => acc + Number(po.total_amount), 0);
        const totalIncome = income || 0;

        this.amounts.totalIncome = totalIncome;
        this.amounts.totalSpent = totalSpent;
        this.amounts.total = totalIncome - totalSpent;
      },
      async closePurchaseOrdersByMonth({month, year}) {
        let parsedMonth = Number(month);
        let selectedCompanies = this.getSelectedCompaniesForMonth(year, month);
        const monthPurchaseOrders = this.getMonthPurchaseOrders(year, month);

        const selectedRows = monthPurchaseOrders.filter((row) => selectedCompanies.indexOf(row.company_id) !== -1);
        const securedRows = selectedRows.filter((row) => Boolean(row.is_secured_investment));
        const regularCompanyIds = [];

        selectedRows.forEach((row) => {
          if (!row.is_secured_investment && regularCompanyIds.indexOf(row.company_id) === -1) {
            regularCompanyIds.push(row.company_id);
          }
        });

        if (selectedCompanies.length === 0) {
          this.$vs.notify({
            title: 'Atención',
            text: 'Debe seleccionar al menos una empresa para generar las ODC',
            color: 'warning'
          });
          return;
        }

        this.$vs.notify({
          title: 'Cerrando',
          text: 'Generando ordenes de compra...',
          color: 'dark',
          loading: true,
          duration: 0
        });

        try {
          if (regularCompanyIds.length > 0) {
            let data = {
              force: true,
              month: parsedMonth,
              year: year,
              company_ids: regularCompanyIds
            }

            await this.$http.post(`${appConfig.apiUrl}/campaigns/${this.modalData.campaignId}/split_purchase_orders`, data)
          }

          if (securedRows.length > 0) {
            await this.createSecuredPurchaseOrdersForRows(securedRows)
          }

          this.$vs.notify({
            title: 'Cerrado',
            text: 'Ordenes de compra generadas correctamente',
            color: 'success'
          });
          this.getPurchaseOrderData()
        } catch (error) {
          console.error('[ClosingsDetails] Error closing purchase orders:', error);
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            color: 'danger'
          });
        }
      },
      closePurchaseOrdersByParams(params){
        this.$vs.notify({
          title: 'Cerrando',
          text: 'Cerrando ordenes de compra...',
          color: 'dark',
          loading: true,
          duration: 0
        });
        return this.$http.post(`${appConfig.apiUrl}/campaigns/${this.modalData.campaignId}/split_purchase_orders`, params)
          .then(() => {
            this.$vs.notify({
              title: 'Cerrado',
              text: 'Ordenes de compra cerradas correctamente',
              color: 'success'
            });
            this.getPurchaseOrderData()
          })
          .catch((error) => {
            console.error('[ClosingsDetails] Error closing purchase orders:', error);
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              color: 'danger'
            });
            throw error;
          });
      },
      handleClose() {
          this.selectedCompaniesByMonth = {};
          this.showCanceledOdcsByMonth = {};
          this.$emit('update:modalActive', false);
      },
      getTooltipContainer() {
        return this.$el.closest('.vs-popup--content') || document.body;
      },
    },
  }


</script>
